module.exports = __webpack_public_path__ + "static/media/frog(18).740e0b3c.PNG";